'use strict';

/**
 * @description Initialize event handlers on landing page
 */

function mistral2Carousel1Init() {
    var $mistral2Carousel1 = $('.js-mistral-carousel-1'),
        slideCount = Math.floor($mistral2Carousel1.data('count') / 2);

    var setMistral2Carousel1 = function () {
        if ($mistral2Carousel1.length) {
            if ($mistral2Carousel1.hasClass('slick-initialized')) {
                $mistral2Carousel1.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                carouselConfig = {
                    slidesToShow: isMobile ? 1 : (isTablet ? 1 : 3),
                    slidesToScroll: 1,
                    centerMode: isMobile ? false : true,
                    centerPadding: isTablet ? '180px' : '150px',
                    variableWidth: isMobile ? false : true, // require to apply zoom effect on .slick-center via css
                    speed: isMobile ? 300 : 0, // to avoid horizontal jumping on centerMode with zoom effect on active slide
                    dots: true,
                    arrows: false,
                    infinite: true,
                    initialSlide: slideCount
                };

            if (isMobile) {
                $mistral2Carousel1.slick(carouselConfig);
            }
            else {
                $mistral2Carousel1.slick(carouselConfig).slick('setPosition');
            }
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setMistral2Carousel1();
    }, 200));

    setMistral2Carousel1();
}

function mistral2Carousel2Init() {
    var $mistral2Carousel2 = $('.js-mistral-carousel-2');

    var setMistral2Carousel2 = function () {
        if ($mistral2Carousel2.length) {
            if ($mistral2Carousel2.hasClass('slick-initialized')) {
                $mistral2Carousel2.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobileAndTablet'),
                carouselConfig = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true
                };

            if (!isMobile) {
                carouselConfig.appendArrows = '#js-mistralCarousel2Arrows';
            }

            $mistral2Carousel2.slick(carouselConfig);
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setMistral2Carousel2();
    }, 200));

    setMistral2Carousel2();
}

function mistral2Carousel3Init() {
    // Initialize product carousel
    var $mistral2ProductCarousel = $('.js-mistral-productcarousel');

    var setMistral2ProductCarousel = function () {
        if ($mistral2ProductCarousel.length) {
            if ($mistral2ProductCarousel.hasClass('slick-initialized')) {
                $mistral2ProductCarousel.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet');

            $mistral2ProductCarousel.slick({
                slidesToShow: isMobile ? 1 : (isTablet ? 3 : 4),
                slidesToScroll: isMobile ? 1 : (isTablet ? 3 : 4),
                dots: true,
                arrows: false
            });
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setMistral2ProductCarousel();
    }, 200));

    setMistral2ProductCarousel();
}

function mistral2Carousel4Init() {
    var $mistral2Carousel4 = $('.js-mistral-carousel-4');

    var setMistral2Carousel4 = function () {
        if ($mistral2Carousel4.length) {
            if ($mistral2Carousel4.hasClass('slick-initialized')) {
                $mistral2Carousel4.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobileAndTablet'),
                isDesktop = window.vbqUtils.breakpoint.is('fromDesktop');

            $mistral2Carousel4.slick({
                slidesToShow: isMobile ? 1 : (isDesktop ? 2 : 3),
                slidesToScroll: isMobile ? 1 : (isDesktop ? 2 : 3),
                dots: true,
                arrows: false,
                infinite: isMobile ? true : false
            });
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setMistral2Carousel4();
    }, 200));

    setMistral2Carousel4();
}

function mistral2Newsletter() {
    // standard form validation (formPrepare.js, validationLogic.js, ...) can not be used here
    // so the form status and error message are managed directly through jQuery validator
    var $form = $('#js-landingNewsletterSubscription');

    if ($form.length) {
        var $formfieldset = $form.find('.gl_form-group'),
            $email = $form.find('#js-landingNewsletterEmail'),
            $errorMessage = $form.find('.gl_error-message'),
            validator = $form.validate(),
            options = {};

        $email.rules('add', {
            required: true,
            email: true
        });

        $email.on('keyup input', window.vbqUtils._debounce(function () {
            if ($(this).val() !== '') {
                validator.element(this);
            }
        }, 200));

        // put back the form in pristine state (input with no value, no error)
        validator.resetForm();
        $formfieldset.removeClass('gl_has-error');

        // run submit if submit button was clicked
        $form.on('click', '.gl_input-submit.mistral-newsletter-submit', function (e) {
            e.preventDefault();

            $form.submit();
        });

        //handle submit form logic for mistral2 newsletter form
        $form.on('submit', function (e) {
            e.preventDefault();

            if (!$form.valid()) {
                return false;
            }

            var email = $email.val(),
                source = $email.data('source'),
                optin = $form.find('.optin').prop('checked');

            //send email to server
            $.ajax({
                method: 'POST',
                url: window.Urls.subscribeToNewsletter,
                data: {
                    email: email,
                    source: source,
                    optinconsent: optin
                },
                cache: false,
                beforeSend: function () {
                    options = {};
                    $formfieldset.removeClass('gl_has-success gl_has-error').addClass('gl_loading');
                }
            }).done(function (data) {
                // GDPR-33 - GDPR - Revision of consents
                if (!data.error && data.type == 'success') {
                    $formfieldset.removeClass('gl_loading').addClass('gl_has-success');
                    $form.addClass('hidden');
                    $('.js-landingNewsletterSubscriptionSuccess').removeClass('hidden');
                }
                // GDPR-26 - GDPR - Mistral2 Modal - New consent modal
                else if (!data.error && data.type == 'consents') {
                    window.vbqUtils.dialog.open({
                        url: window.Urls.getConsentForm,
                        options: {
                            width: 'auto',
                            dialogClass : 'consent-dialog',
                            open: function () {
                                window.vbqUtils.initializeJQueryUiPlugins();

                                var $consentForm = $('#js-newsletterSubscriptionConsents'),
                                    $newsletterSubscriptionConsentsButton = $('#js-newsletterSubscriptionConsentsButton');

                                $newsletterSubscriptionConsentsButton.click(function () {
                                    $newsletterSubscriptionConsentsButton.attr('disabled', 'disabled');
                                    window.vbqUtils.progress.show($newsletterSubscriptionConsentsButton);

                                    $.ajax({
                                        method: 'POST',
                                        url: window.Urls.consentForNewsletterSubscription,
                                        data: {
                                            email: email,
                                            source: source,
                                            optinconsent: $consentForm.find('#dwfrm_profile_customer_optinconsent').prop('checked')
                                        },
                                        cache: false,
                                        beforeSend: function () {
                                            options = {};
                                            $formfieldset.removeClass('gl_has-success gl_has-error').addClass('gl_loading');
                                        }
                                    }).done(function (data) {
                                        $formfieldset.removeClass('gl_loading');

                                        if (!data.alert && data.type == 'success') {
                                            $formfieldset.addClass('gl_has-success');
                                            $form.addClass('hidden');
                                            $('.js-landingNewsletterSubscriptionSuccess').removeClass('hidden');
                                        }
                                        else {
                                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL_GLOBAL;
                                            validator.showErrors(options);
                                        }

                                        window.vbqUtils.dialog.close();
                                    }).fail(function () {
                                        $formfieldset.removeClass('gl_loading');
                                        options[$email.attr('name')] = window.Resources.SERVER_ERROR;
                                        validator.showErrors(options);
                                        window.vbqUtils.dialog.close();
                                    });
                                });
                            }.bind(this)
                        }
                    });
                }
                else {
                    $formfieldset.removeClass('gl_loading');
                    switch (data.type) {
                        case 'format':
                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL;
                            break;
                        case 'already':
                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL_ALREADY;
                            break;
                        default:
                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL_GLOBAL;
                            break;
                    }
                    validator.showErrors(options);
                }
            }).fail(function () {
                $formfieldset.removeClass('gl_loading');
                options[$email.attr('name')] = window.Resources.SERVER_ERROR;
                validator.showErrors(options);
            });
        });
    }
}

window.addEventListener('mainJsLoaded', function () {
    mistral2Newsletter();
    mistral2Carousel1Init();
    mistral2Carousel2Init();
    mistral2Carousel3Init();
    mistral2Carousel4Init();
});
